

import * as React from "react";
// api 
import { ISP_Room, QUALITY } from './types'
import { IoLeafSharp } from 'react-icons/io5'
import { themedUseStyletron } from '../../../theme/customTheme';
import { LabelLarge, LabelXSmall } from "baseui/typography";
import { Block } from "baseui/block";
import { ValueDisplayIcon } from "../../components/ValueDisplay";
// api
import { useGetObjectsChildren } from "../../../hooks/useGetObjectsChildren";
import { FormattedMessage } from 'react-intl';
import { getQualityColor } from "./utils";
import { OptimalConditionsText } from "./OptimalConditionsText";

export function RoomQuality(props: ISP_Room) {
    const [css, theme] = themedUseStyletron();

    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const temperature = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
    const humitity = childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.HumiditySensor");

    const bad = props.humidityQuality === QUALITY.Bad || props.temperatureQuality === QUALITY.Bad;
    const sufficient = props.humidityQuality === QUALITY.Sufficient || props.temperatureQuality === QUALITY.Sufficient;
    const color = bad ? theme.colors.negative500 : sufficient ? theme.colors.warning500 : theme.colors.positive;


    return (
        <Block display={'flex'} flexDirection={'column'} alignItems={'center'} gridGap={theme.sizing.scale400}>
            <Block display='flex' flexDirection='row' gridGap={theme.sizing.scale600} alignItems='center'>

                <IoLeafSharp opacity={'0.5'} size='1.0em' color={color} />

                <Block display='flex' flexDirection='row' gridGap={theme.sizing.scale600}>
                    {temperature &&
                        <Block display={'flex'} flexDirection={'column'} alignItems={'center'}>
                            <ValueDisplayIcon   {...temperature}></ValueDisplayIcon>
                            {props.temperatureQuality === QUALITY.Bad && <LabelXSmall color={theme.colors.negative500}><FormattedMessage id="SP_Room.QualityBad" defaultMessage="Bad" /></LabelXSmall>}
                            {props.temperatureQuality === QUALITY.Sufficient && <LabelXSmall color={theme.colors.warning500}><FormattedMessage id="SP_Room.QualitySufficient" defaultMessage="Sufficient" /></LabelXSmall>}
                        </Block>
                    }
                    {humitity &&
                        <Block display={'flex'} flexDirection={'column'} alignItems={'center'}>
                            <ValueDisplayIcon   {...humitity}></ValueDisplayIcon>
                            {props.humidityQuality === QUALITY.Bad && <LabelXSmall color={theme.colors.negative500}><FormattedMessage id="SP_Room.QualityBad" defaultMessage="Bad" /></LabelXSmall>}
                            {props.humidityQuality === QUALITY.Sufficient && <LabelXSmall color={theme.colors.warning500}><FormattedMessage id="SP_Room.QualitySufficient" defaultMessage="Sufficient" /></LabelXSmall>}
                        </Block>}
                </Block>

            </Block>
            {(bad || sufficient) &&

                <OptimalConditionsText roomUsage={props.usage}></OptimalConditionsText>
            }
        </Block>
    );
}





